<ion-item lines="none" class="ion-no-padding">
  <ion-label *ngIf="!hideLabel" position="stacked">{{ label + (required ? '*' : '')  }}</ion-label>
  <ion-input [type]="type" [id]="id" [placeholder]="placeholder" [(ngModel)]="value" 
    [minlength]="minLength" [maxlength]="maxLength"
    [disabled]="disabled" (ionBlur)="checkValidity()" 
    [debounce]="debounce" [autocomplete]="autoComplete" [inputFocus]="focus"></ion-input>
  <!-- <ion-button slot="end" *ngIf="isMobile" class="showbtn" (click)="toggleShow()" fill="clear">{{type === 'text' ? 'Hide' : 'Show'}}</ion-button> -->
</ion-item>